import { useMessages } from '@src/@data/utility/hooks/useMessages';
import { useInternationalization } from '../../@data/store/InternationalizationProvider';

export const BUSINESS_APP_APPLE_STORE_LINK =
  'https://apps.apple.com/us/app/bookla-business/id1493198111';

export const AppleStoreButton: React.FC = () => {
  const { language } = useInternationalization();
  const { messages } = useMessages();

  return (
    <a
      href={BUSINESS_APP_APPLE_STORE_LINK}
      rel="noopener noreferrer"
      target="_blank"
      className="flex-shrink-0 d-block"
      style={{ height: '44px', margin: '10px' }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/appleStoreBadges/${language}/dark.svg`}
        alt={messages('apple_store_button_alt')}
        className="h-100"
      />
    </a>
  );
};
